<script>
import FormGridBox from '../../FormGuideSelectionStats/FormGridBox.vue';
import AccordionTransition from '../common/AccordionTransition.vue';
export default {
  name: 'LongFormModalRow',
  components: {
    FormGridBox,
    AccordionTransition,
  },
  props: {
    competitorId: {
      type: String,
      required: true,
    },
    record: {
      type: Object,
      required: true,
    },
    expandAll: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showDetails: false,
    };
  },
  computed: {
    eventHeader() {
      const { venue } = this.record;
      return venue ? `${venue.name} R${this.record.event_number}` : '';
    },
    eventRunners() {
      const { record } = this;
      return record.starters || 0;
    },
    eventPlaceWinners() {
      const { record } = this;
      return record.place_numbers || 3;
    },
    distance() {
      return `${this.record.distance}m`;
    },
    raceWinner() {
      const { results } = this.record;
      if (results.length > 0) {
        const filteredResult = results.filter(item => {
          return item.finish_position === '1';
        });
        return filteredResult.length > 0 ? filteredResult[0].competitor_name : '';
      }
    },
    getEventCondition() {
      const { record } = this;
      const entryClass = record.entry_conditions.filter(event => {
        return event.type == 'raceClassRestriction';
      });
      return entryClass.length > 0 ? entryClass[0].description : '';
    },

    selectionPlaceClass() {
      const { selectionResultInfo, placeWinners } = this;
      const position = parseInt(selectionResultInfo('position'));
      if (position === 1) return 'win';
      if (position > 1 && position <= placeWinners) return 'place';
      return '';
    },
    placeWinners() {
      const { record } = this;
      return record.place_winners || 3;
    },
  },
  mounted() {
    if (this.expandAll) {
      this.showDetails = true;
    }
  },
  methods: {
    toggleDetails() {
      this.showDetails = !this.showDetails;
    },
    getGridDetails(row) {
      const { selectionResultInfo, getEventCondition, raceWinner } = this;
      switch (row) {
        case 'firstRow':
          return [
            { header: 'DRIVER', details: selectionResultInfo('jockey') },
            { header: 'BARRIER', details: selectionResultInfo('barrier') },
            { header: 'CLASS', details: getEventCondition },
          ];
        case 'secondRow':
          return [
            { header: 'PRIZE', details: `$${selectionResultInfo('prize')}` },
            { header: 'PRICE', details: '-' },
            { header: 'TIME', details: selectionResultInfo('time') },
          ];
        case 'thirdRow':
          return [
            { header: 'RACE WINNER', details: raceWinner },
            { header: 'MARGIN', details: selectionResultInfo('margin') },
          ];
        default:
          return [];
      }
    },
    selectionResultInfo(type) {
      const { results, prize_money } = this.record;
      if (results.length > 0) {
        const filteredResult = results.filter(item => {
          return item.competitor_id === this.competitorId;
        });
        if (filteredResult.length > 0) {
          // get selections position
          if (type === 'position') return filteredResult[0].finish_position;
          // get selections jockey name
          if (type === 'jockey') return filteredResult[0].jockey_name;
          // get selections barrier
          if (type === 'barrier') return filteredResult[0].barrier;
          // get selections prize money winnings
          if (type === 'prize') {
            const position = filteredResult[0].finish_position;
            const prizeWinningsArray = prize_money.filter(item => {
              return item.position === position;
            });
            return prizeWinningsArray.length > 0 ? prizeWinningsArray[0].value : 0;
          }
          // get selection finish time
          if (type === 'time') return filteredResult[0].finish_time ? `${filteredResult[0].finish_time}` : '-';
          // get selections margin from winner
          if (type === 'margin') return filteredResult[0].margin_decimal ? `${filteredResult[0].margin_decimal}L` : '-';
        }
      }
    },
  },
};
</script>

<template>
  <div class="long-form-modal-container">
    <a href="#" class="long-form-modal-row" @click.prevent="toggleDetails">
      <div class="long-form-modal-row__header">
        <div class="long-form-modal-row__left">
          <div :class="`long-form-modal-row__left-text ${selectionPlaceClass} `">
            <p>{{ selectionResultInfo('position') }}</p>
          </div>
          <div>of {{ eventRunners }}</div>
        </div>
        <div class="long-form-modal-row__middle">
          <div class="long-form-modal-row__middle-header">{{ eventHeader }}</div>
          <div class="long-form-modal-row__middle-details">
            <div class="long-form-modal-row__middle-distance">{{ distance }}</div>
            <div class="long-form-modal-row__middle-condition good">Good</div>
          </div>
        </div>
        <div class="long-form-modal-row__right">
          <div :class="{ up: showDetails }" class="long-form-modal-row-chevron">
            <svg width="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path
                d="M12.682 4.018c.3 0 .5.1.7.3.4.4.4 1 0 1.4l-4.5 4.5 4.5 4.5c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-6-6 6-6c.2 0 .4-.1.7-.1"
                fill="#dddbdd"
              />
            </svg>
          </div>
        </div>
      </div>
    </a>
    <!-- expandable accordion for long form details -->
    <AccordionTransition>
      <div v-if="showDetails" class="long-form-modal-row__details">
        <div class="long-form-modal-row__details-container">
          <div class="long-form-modal-row__details-grid">
            <div class="long-form-modal-row__details-row">
              <template v-for="(gridData, index) in getGridDetails('firstRow')">
                <FormGridBox
                  :key="`grid-row-1-${index}`"
                  :header-text="gridData.header"
                  :details-text="gridData.details"
                />
              </template>
            </div>
            <div class="long-form-modal-row__details-row">
              <template v-for="(gridData, index) in getGridDetails('secondRow')">
                <FormGridBox
                  :key="`grid-row-2-${index}`"
                  :header-text="gridData.header"
                  :details-text="gridData.details"
                  class="form-grid-box-below-row"
                />
              </template>
            </div>
            <div class="long-form-modal-row__details-row">
              <template v-for="(gridData, index) in getGridDetails('thirdRow')">
                <FormGridBox
                  :key="`grid-row-3-${index}`"
                  :header-text="gridData.header"
                  :details-text="gridData.details"
                  class="form-grid-box-below-row"
                />
              </template>
            </div>
          </div>
        </div>
      </div>
    </AccordionTransition>
  </div>
</template>
